import React from 'react'

export default function GetUrl() {

    //return "https://boxy.currenmexico.com/legalback/" // Produccion

    //return "https://mxgsesoftware.com/digactiva2/"
    //return "http://localhost:3050/digactiva/"
    //return "http://localhost:3050/digactiva2/"
    //return "http://localhost:3050/dsactivaback/" ( e bueno para pruebas)


    return "https://mxgsesoftware.com/dsactivaback/" // desarollo ( ahora el bueno )

    //return "http://localhost:3050/dsactivaback/" // desarollo
    
}
